require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./configurations-custom-webpack-config.json") })
        }
      }, "path---configurations-custom-webpack-config");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---configurations-custom-webpack-config!./.cache/json/configurations-custom-webpack-config.json
// module id = 419
// module chunks = 231608221292675